import NetworkUtil from "./NetworkUtil";

export class EventAPI{
    public static async getEvents(getZeros = 0):Promise<{schedMap}>{
        return NetworkUtil.makeGet("/api/events/" + getZeros)
    }
}